export default __webpack_public_path__ + "static/media/icon-external.13628129.svg";